export const routes = {
  aboutUs: 'about-us',
  brands: 'our-brands',
  campaign: 'campaign',
  contact: 'contact',
  jobs: 'job-opportunities',
  news: 'news',
  sustainability: 'sustainability',
};
